module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-footer"
  }, [_c('div', {
    staticClass: "row pad"
  }, [_c('div', {
    staticClass: "col s12 m5m offset-mm"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$teras.bvent.titolo))]), _vm._v("\n            " + _vm._s(_vm.$teras.bvent.citta) + ", " + _vm._s(_vm._f("data")(_vm.$teras.bvent.iniziail, 'D MMMM')) + " - " + _vm._s(_vm._f("data")(_vm.$teras.bvent.finisceil, 'LL')) + "\n            "), _c('div', {
    staticStyle: {
      "margin": "20px 0 0 0"
    }
  }, [_vm._v("security: " + _vm._s(_vm.axios.sessionID) + "·" + _vm._s(_vm.$abs.row.evento) + "·" + _vm._s(_vm.$teras.version))])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.assistenzaSection)
    }
  }), _vm._v(" "), (_vm.$teras.evento.id == 136) ? _c('div', [_vm._v("\n                    Per ricevere assistenza potete contattare \n                    "), _c('br'), _vm._v("\n                    I VIAGGI DI SALOMONE-ASCO SRL\n                    "), _c('br'), _vm._v("\n                    Email "), _c('a', {
    attrs: {
      "href": "'mailto:sisvet2024@iviaggidisalomone.it'"
    }
  }, [_vm._v("sisvet2024@iviaggidisalomone.it")])]) : _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.assistenzaHelp)
    }
  }), _vm._v("\n                " + _vm._s(_vm.$teras.evento.responsabile) + "\n                "), _c('br'), _vm._v("\n                Email "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.$teras.evento.responsabileemail
    }
  }, [_vm._v(_vm._s(_vm.$teras.evento.responsabileemail))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1272d6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-footer.vue
// module id = 598
// module chunks = 2